import { FRACTIONS_PER_CURRENCY } from '@/utils/consts';

import { DnDNegotiation } from '../../../../types';

import { GetDemoNegotiationsResponse } from './getDemoNegotiationsResponseStruct';

export const parseGetDemoNegotiationsResponse = (
  response: GetDemoNegotiationsResponse
): DnDNegotiation[] => {
  return response.data.map(
    ({
      id,
      attributes: {
        title,
        termRoles,
        negotiationTypes,
        periodIndex,
        estimatedDiscount,
        estimatedInflation,
        totalSpend,
        suppliersCount,
        potentialCostAvoidance,
        potentialSavings,
        periodOrder,
        createdAt,
      },
    }) => ({
      id,
      title,
      termRoles,
      negotiationTypes,
      // cents to complete currency
      totalSpend: totalSpend / FRACTIONS_PER_CURRENCY,
      periodIndex,
      periodOrder,
      createdAt,
      metrics: {
        estimatedDiscount,
        estimatedInflation,
        suppliersCount,
        // cents to complete currency
        potentialCostAvoidance: potentialCostAvoidance / FRACTIONS_PER_CURRENCY,
        // cents to complete currency
        potentialSavings: potentialSavings / FRACTIONS_PER_CURRENCY,
      },
    })
  );
};
